export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-foreground-900 font-heading font-bold text-lg">911黑料网</span>
            </div>
            <p className="text-xs text-foreground-500 leading-relaxed mb-4">
              全网黑料吃瓜第一站。整合911黑料吃瓜网、911吃瓜黑料网官方入口，
              最新黑料事件与网站导航一站直达。快速访问不迷路，吃瓜永远快人一步。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-weibo-line"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-wechat-line"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-vidicon-line"></i>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-foreground-900 text-sm mb-4">快速导航</h3>
            <nav className="flex flex-col gap-2">
              <a href="#updates" onClick={(e) => handleNavClick(e, '#updates')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">最新快讯</a>
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">热门榜单</a>
              <a href="#media" onClick={(e) => handleNavClick(e, '#media')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">视频专区</a>
              <a href="#carousel" onClick={(e) => handleNavClick(e, '#carousel')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">焦点专题</a>
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">精选黑料</a>
            </nav>
          </div>

          <div>
            <h3 className="font-heading font-bold text-foreground-900 text-sm mb-4">热门话题</h3>
            <div className="flex flex-wrap gap-2">
              {['明星塌房', '恋情曝光', '综艺黑幕', '网红翻车', '税务风波', '人设崩塌', '私生活爆料', '整容争议'].map((tag) => (
                <span
                  key={tag}
                  className="text-[10px] px-2.5 py-1.5 rounded-full bg-background-200 text-foreground-500 cursor-pointer hover:bg-primary-500/10 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  #{tag}
                </span>
              ))}
            </div>
            <h3 className="font-heading font-bold text-foreground-900 text-sm mb-3 mt-6">合作伙伴</h3>
            <p className="text-xs text-foreground-400">优质合作伙伴持续招募中</p>
          </div>

          <div>
            <h3 className="font-heading font-bold text-foreground-900 text-sm mb-4">联系我们</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-mail-line text-primary-500"></i>
                tips@911heiliaowang.com
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-wechat-line text-accent-500"></i>
                911黑料网官方客服
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-shield-check-line text-primary-500"></i>
                爆料人隐私绝对保护
              </div>
            </div>
            <h3 className="font-heading font-bold text-foreground-900 text-sm mb-3 mt-6">免责声明</h3>
            <p className="text-[10px] text-foreground-400 leading-relaxed">
              本站内容来源于网友投稿与公开信息整理，仅供参考。如涉及侵权请联系我们删除。
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[10px] text-foreground-400">
            &copy; 2019-2026 911黑料网. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-[10px] text-foreground-400">
            <span className="cursor-pointer hover:text-primary-500 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-500 transition-colors">用户协议</span>
            <span className="cursor-pointer hover:text-primary-500 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}